/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    ROLES_title: "Rôles de privilèges",
    ROLES_label: "rôle",
    ROLES_plural_label: "rôles",
    ROLES_create: "Créer un rôle",
    ROLES_edit: "Modifier le rôle",
    ROLES_back: "Retour aux rôles",

    ROLES_columnName: "Rôle",
    ROLES_columnDescription: "Description",
    ROLES_columnPrivileges: "Privilèges",
    ROLES_columnUpdatedBy: "Modifié par",

    ROLES_fieldName: "Nom du rôle",
    ROLES_fieldNamePlaceholder: "ex. Administrateur",
    ROLES_fieldDescription: "Description",
    ROLES_fieldDescriptionPlaceholder: "À quoi sert ce rôle",

    ROLES_privilegesTitle: "Privilèges",
    ROLES_resourcePlan: "Plan",
    ROLES_resourceCoupon: "Bon de réduction",
    ROLES_resourceCustomer: "Client",
    ROLES_resourceAdsPublication: "Portail d'annonces",

    ROLES_rightRead: "Lire",
    ROLES_rightUpdate: "Modifier",
    ROLES_rightCreate: "Créer",

    ROLES_grantedCount: "Aucun privilège | 1 privilège | {count} privilèges",
    ROLES_protectedBadge: "Protégé",
    ROLES_protectedRole: "Ce rôle est protégé et ne peut pas être modifié.",

    ROLES_confirmCreate: "Créer le rôle",
    ROLES_save: "Enregistrer",

    ROLES_createSuccessTitle: "Rôle",
    ROLES_createSuccessMessage: "Le rôle a été créé avec succès.",
    ROLES_updated: "Rôle mis à jour.",
    ROLES_updateTitle: "Rôle",

    ROLES_deleteConfirm: "Êtes-vous certain de vouloir supprimer ce rôle ?" +
        " | Êtes-vous certain de vouloir supprimer ces rôles ?",
    ROLES_cannotDelete: "Ce rôle ne peut pas être supprimé.",
    ROLES_superAdminOnly: "Seul un Super Admin peut créer ou modifier des rôles.",
    ROLES_privilegesSelected: "{n} privilège sélectionné | {n} privilèges sélectionnés",
    ROLES_fullAccessNotice: "Ce rôle dispose par défaut de tous les droits sur l'ensemble des " +
        "ressources. Aucun privilège à configurer.",

    ROLES_splashScreenTitle: "Créez votre premier rôle",
    ROLES_splashScreenDescription: "Un rôle regroupe les privilèges accordés aux utilisateurs " +
        "de la Console."
};
